/**
 * Standard Email Validation
 * Returns true if valid or empty (optional field logic should be handled by caller)
 */
export const validateEmail = (email) => {
    if (!email) return true; 
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
};


export const validatePassword = (password, username = '') => {
    // If no password is provided, everything is 'false' or 'neutral'
    if (!password) {
        return {
            minLength: false,
            hasUpper: false,
            hasNumber: false,
            hasSpecial: false,
            notUsername: false,
            notCommon: false,
            isEmpty: true // Helper flag
        };
    }

    return {
        minLength: password.length >= 8,
        hasUpper: /[A-Z]/.test(password),
        hasNumber: /[0-9]/.test(password),
        hasSpecial: /[!@#$%^&*(),.?":{}|<>]/.test(password),
        notUsername: password.toLowerCase() !== username.toLowerCase(),
        notCommon: !['password', '12345678', 'qwerty'].includes(password.toLowerCase()),
        isEmpty: false
    };
};


/**
 * Generates a human-friendly (but secure) password
 * Example: "BraveCloud42!"
 */
export const generateSecurePassword = () => {
    const adjectives = [
        "Bold", "Calm", "Cool", "Dark", "Fast", "Fine", "Free", "Glad", "Holy", "Kind", "Loud", "Mild", 
        "Pure", "Real", "Soft", "Agile","Brave", "Brief", "Clear", "Fresh", "Grand", "Great", "Light", 
        "Lucky", "Noble", "Quick", "Rapid", "Sharp", "Smart", "Solid"
    ];
    const nouns = [
        "Atom", "Base", "Bird", "Blue", "Boat", "Book", "Code", "Door", "Fire", "Grid", "Icon", "Leaf", 
        "Moon", "Peak", "Road", "Star","Wave", "Wind", "Cloud", "Field", "Flame", "Light", "Logic", "Ocean", 
        "Pilot", "River", "Solar", "Data", "Link", "Flow"
    ];
    const symbols = "!@#$%^&*";

    const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    const num = Math.floor(Math.random() * 90) + 10;
    const sym = symbols.charAt(Math.floor(Math.random() * symbols.length));

    return `${adj}${noun}${num}${sym}`;
};